import type { MRT_ColumnDef } from "mantine-react-table-open";
import { sortBackendDates } from "../../../../../utils/dates/sortBackendDates";
import type { Contract } from "../../../DeliveryOverview.types";

export function getBeginColumn(
  contracts: Array<Contract>
): MRT_ColumnDef<Contract> {
  const usedBegins = contracts
    .map((contract) => contract.begin)
    .sort((beginA, beginB) => sortBackendDates(beginA, beginB));
  const usedBeginsSet = Array.from<string>(new Set(usedBegins));
  const uniqueUsedBegins = Array.from(usedBeginsSet);

  return {
    accessorKey: "begin",
    accessorFn: (row) => row.begin,
    header: "Vertragsbeginn",
    sortingFn: (rowA, rowB) =>
      sortBackendDates(rowA.original.begin, rowB.original.begin),
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedBegins
    }
  };
}
